import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  class: /*#__PURE__*/_normalizeClass(['modal__content'])
}
const _hoisted_2 = { class: "modal__content__header" }
const _hoisted_3 = { class: "modal__content__body" }
const _hoisted_4 = {
  key: 0,
  class: "modal__content__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.isActive)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['modal modal--dismissible', { 'modal--active': _ctx.isActive }]),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggle()), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "modal__close",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggle()), ["self"]))
            }),
            _createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "header")
            ]),
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "body")
            ]),
            (_ctx.hasFooterSlot)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _renderSlot(_ctx.$slots, "footer")
                ]))
              : _createCommentVNode("", true)
          ], 512)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}